import React from "react";
import "./style.css";

export const Roadassist = () => {
    return (
        <div className="roadassist-container">
            <div className="promo-title">ПОЧЕМУ ROAD ASSIST?</div>

            <div className="card">
                <p className="description">
                    ООО <strong>"Road Assist"</strong> — это надёжный партнёр в сфере страхования и технической помощи на дорогах. Наша основная специализация — продажа полисов КАСКО от ведущих страховых компаний Узбекистана, с которыми мы сотрудничаем напрямую.
                    <br /><br />
                    Понимая потребности наших клиентов, мы предлагаем не просто страхование, а комплексную заботу об автовладельцах. Каждый клиент, оформивший полис КАСКО через Road Assist, получает в подарок пакет услуг технической помощи:
                    <ul>
                        <li>эвакуация автомобиля</li>
                        <li>запуск двигателя при разрядке аккумулятора</li>
                        <li>подкачка и ремонт колеса</li>
                        <li>доставка топлива</li>
                        <li>выезд аваркома</li>
                        <li>услуги эвакуатора</li>
                        <li>организация услуг такси на период ремонта авто</li>
                    </ul>
                    На текущем этапе услуги техпомощи предоставляются по городу Ташкент.
                    <br /><br />
                    Наша команда — это профессиональные специалисты, готовые прийти на помощь в любой ситуации. Мы стремимся создать для клиентов ощущение уверенности и безопасности на дороге, предлагая сервис высокого уровня и персональный подход.
                </p>
            </div>
        </div>
    );
};
